import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './cardFooterStyle.js'

export default function CardFooter(props) {
  const {
    className,
    children,
    plain,
    profile,
    pricing,
    testimonial,
    stats,
    chart,
    product,
    ...rest
  } = props
  return (
    <Box
      component={'div'}
      sx={[
        styles.cardFooter,
        plain && styles.cardFooterPlain,
        (profile || testimonial) && styles.cardFooterProfile,
        pricing && styles.cardFooterPricing,
        testimonial && styles.cardFooterTestimonial,
        stats && styles.cardFooterStats,
        (chart || product) && styles.cardFooterChart,
      ]}
      className={className}
      {...rest}
    >
      {children}
    </Box>
  )
}

CardFooter.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  pricing: PropTypes.bool,
  testimonial: PropTypes.bool,
  stats: PropTypes.bool,
  chart: PropTypes.bool,
  product: PropTypes.bool,
  children: PropTypes.node,
}
